import { gql } from '@apollo/client';

export const MY_CB_TALENT_LIST = gql`
  query MyCbTalentList($input: MyCbTalentListInput!) {
    myCbTalentList(input: $input) {
      entities {
        id
        source
        status
        type
        lastRate
        createdAt
        firstWorkedAt
        lastWorkedAt
        archivedAt
        ... on CbMyOnPlatformTalent {
          userId
          workedWith
          user {
            id
            firstName
            lastName
            avatarUrl
            email
            sports {
              id
              name
            }
            socialMedia {
              id
              type
              username
              followingCnt
              engagementRate
            }
            influencerCategories {
              id
              name
            }
          }
        }
      }
      total
      limit
      offset
    }
  }
`;
